import React from 'react'
import { motion } from "framer-motion";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PublicIcon from '@mui/icons-material/Public';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

export default function LoanBenifit() {
    const data = [
    {
      title: "Relatively High Interest Rate",
      icon:<TrendingUpIcon/>,
      desc: "Our credit products are structured for speed and accessibility. Please note that interest rates are typically higher than conventional bank loans, such as standard automobile or mortgage loans.",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-500",
      cardStyle: "bg-white border border-gray-200 text-gray-900",
    },
    {
      title: "Indian Residents Only",
       icon:<PublicIcon/>,
      desc: "B4Salary's lending services are available exclusively to Indian citizens residing within India. All loan applications are subject to eligibility criteria, verification, and applicable regulatory requirements.",
      iconBg: "bg-blue-700",
      iconColor: "text-white",
      cardStyle: "bg-[#011F41] text-white",
    },
    {
      title: "Salary Loans",
       icon:<CurrencyRupeeIcon/>,
      desc: "We offer specialized short-term liquidity solutions for professionals. This service is designed for salaried individuals with a verified minimum monthly income of INR 25,000/-.",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-500",
      cardStyle: "bg-white border border-gray-200 text-gray-900",
    },
  ];
  return (
     <section className="px-4 sm:px-6 lg:px-8 py-20">
      <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            RISKS
          </h2>
          <p className="text-gray-500 mt-2">
            A disclaimer before you apply
          </p>
        </div>
      <div className="max-w-7xl mx-auto">


        {/* Grid */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.2,
              },
            },
          }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {data.map((item, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 40 },
                visible: { opacity: 1, y: 0 },
              }}
              whileHover={{ scale: 1.03 }}
              className={`p-6 rounded-xl shadow-sm transition-all duration-300 ${item.cardStyle}`}
            >
              {/* Icon */}
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${item.iconBg}`}
              >
               
                  {item.icon}
              </div>

              {/* Title */}
              <h3 className="font-bold text-lg mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-sm opacity-80 leading-6">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  )
}
